import { Directive ,ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPanValidation]'
})
export class PanValidationDirective {
  private regExp: RegExp = new RegExp(/[A-Za-z]{5}\d{4}[A-Za-z]{1}$/g);

  //new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);
  //(/^[1-9][0-9]{0,5}$/g);
  //pan/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/g

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home','ArrowLeft','ArrowRight','Delete'];

  constructor(private element: ElementRef) {
  }

  @HostListener('keydown', ['$event'])

  onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.element.nativeElement.value;

    

    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regExp)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src735431561/src/src/app/shared/directive/pan-validation.directive.ts